<template>
    <div id="baseCarousel" class="">
        <div class="content">
            <ul class="list-unstyled" ref="scroller" style="padding:0px 10px">
                <li v-for="(book,index) in books" :key="index" >
                    <div class="imgTop mb-2"><img v-bind:src="book.image" alt=""></div>
                    <b v-html="$options.filters.decoder(book.header)"></b>
                    <p v-html="$options.filters.decoder(book.subtitle)"></p>
                    <p v-html="$options.filters.decoder(book.body)"></p>
                    <div class="row">
                        <div class="col"><a :href="book.url">Lees meer</a></div>
                        <div class="col price mr-2" v-html="book.price">{{ book.price }}</div>
                    </div>
                </li>
                 
            </ul>
        </div>

        <a v-on:click="scrollLeft()" class="left-arr">
            <img src="../../assets/images/left2.png" alt=""> 
        </a>
        <a v-on:click="scrollRight()" class="right-arr">
            <img src="../../assets/images/right2.png" alt=""> 
        </a>
    </div>
</template>



<script> 
    export default {
        name:'baseCarousel',
        props:{
            books:{type:Array,required:true}
        },
        data(){
            return {
            }
        },
        methods:{
            scrollLeft:function(){
                let width = this.$refs.scroller.getElementsByTagName('li')[0].clientWidth+50
                this.$refs.scroller.scrollLeft-= width; 
            },
            scrollRight:function(){
                let width = this.$refs.scroller.getElementsByTagName('li')[0].clientWidth+50
                console.log(width);
                this.$refs.scroller.scrollLeft+=width; 
            }
        },
        filters:{
            decoder : function(value){
                if (!value) return ''
                return window.atob(value);
            }
        }
    }
</script>

<style scoped> 
    .imgTop{
        height: 140px;
    }
    .left-arr{
        display: block;
        position: absolute;
        top: 8%;
        left: -3%;
    }
    .left-arr img{
        width: 100px;
    }
    .left-arr:hover , .right-arr:hover{
        cursor: pointer;
    }
    .right-arr{
        display: block;
        position: absolute;
        top: 8%;
        right: -3%;
    }
     .right-arr img{
        width: 100px;
     }
    #baseCarousel{
        position: relative;
        border-top:2px solid gray;
        overflow: hidden;
    } 
    #baseCarousel ul{
        display: flex;
        padding-left: 10px;
        overflow-x: hidden;
        overflow-y: hidden;
        flex-direction: row;
    }
    #baseCarousel ul li{
        width: 253px;
        text-align: center;
        border-right:1px solid black;
        margin: 15px 0px;
        padding-top: 0px;
        display: inline-block;
        padding-left: 13px;  
        /* margin-right: 21px; */
    }
    #baseCarousel ul li img{
        max-width: 129px;
        max-height: 142px;
        margin: 0px 86px 15px 75px;
        padding: 10px;
    }
    #baseCarousel ul li b{
        display: block;
        text-align: left;
        padding:0px 13px;
    }
    #baseCarousel ul li p{
        text-align: left;
        padding:0px 13px;
        font-size:13px;
    }
    #baseCarousel ul li .price{
        text-align: right;
        font-weight: bold;
    }
    #baseCarousel ul li a{
        text-decoration: none;
        color:black;
        text-align: left;
        display: block;
        font-weight: bold;
        font-size:large;
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/base-carousel.vue